import curd from '../curd'

const BASE_PATH = '/key/component'

export default curd(BASE_PATH)



// WEBPACK FOOTER //
// ./src/apis/modules/KeyComponent.js